import React from 'react';
import intl from 'react-intl-universal';
import styles from './index.module.scss';

const Loading = (): React.ReactElement => (
  <div className={styles.loadingContainer}>
    <div className={styles.loadingBox}>
      <i className={styles.loadingIcon}></i>
      <p className={styles.loadingText}>{intl.get('COMMON_LOADING_TEXT')}</p>
    </div>
  </div>
)

export default Loading;